<template>
  <div class="homePage">
    <MobileHead />
    <div class="homeContent">
      <LoopImg />
      <div class="bbody">
        <div class="container">
          <!-- 搜索框 -->
          <div class="goldBox">
            <div class="title">{{ $t('homePage.quickFind') }}</div>
            <div class="search">
              <div class="row1">
                <div class="selectBox">
                  <el-select slot="prepend" v-model="select" :placeholder="$t('homePage.placeholder1')" popper-class="sel">
                    <el-option
                      v-for="(item, index) in category"
                      :key="index"
                      :label="$t('homePage.searchCategory.searchCategory' + item.key)"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </div>
                <div class="selecTree">
                  <div class="inputSelect" @click="openPanel">
                    <span v-if="!selectProductType">{{ holder }}</span>
                    <span v-else>{{ selectProductType }}</span>
                    <i class="el-icon-arrow-down" v-if="!selectvisible"></i>
                    <i class="el-icon-arrow-up" v-else></i>
                  </div>
                </div>
              </div>
              <div class="row2">
                <div class="searchBox">
                  <el-input v-model="search" :placeholder="$t('homePage.placeholder2')"></el-input>
                </div>
                <div class="btn">
                  <el-button icon="el-icon-search" @click="searchClick()">{{ $t('homePage.search') }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="recommendEx">
        <div class="recommended">{{ $t('homePage.productRecommend') }}</div>
        <div class="exhibitionsLists">
          <div class="exItem" v-for="(item, index) in recommendExLists" :key="index">
            <div class="navTitle">
              <div class="img"><img :src="item.imgUrl" alt="" /></div>
              <div class="titlee">{{ item.label }}</div>
            </div>
            <div class="content">
              <div v-for="(i, k) in item.lists" :key="k" class="swiper-slide ">
                <div class="card" @click="goDetail(i.id)">
                  <div class="parameter">
                    <div class="title">{{ lang == 'zh' ? i.exhibitsName : i.column25 }}</div>
                    <div class="english">{{ i.column23 }}</div>
                    <div class="txt">{{ i.column19 }}</div>
                  </div>
                  <div class="backImg">
                    <img :src=" i.exhibitsCoverImg" alt="" v-if="i.exhibitsCoverImg.substr(0,4) == 'http'" />
                    <img :src="baseUrl+i.exhibitsCoverImg" alt="" v-else />
                    <img src="../../../static/占位-展品-列表.png" alt="" v-else />
                  </div>
                  <div class="companyName">
                    <span class="leftTitle">{{ lang == 'zh' ? i.companyNameC : i.companyNameE }}</span>
                  </div>
                </div>
              </div>
              <div class="viewMore" @click="viewMore(item.label)">
                {{ $t('common.viewMoreMobile') }}
                <span>
                  <img src="../../../static/lookMore.png" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VRSee />
      <Recommend />
      <div class="advertising">
        <img alt="" src="../../../static/homebanner.png" v-if="lang == 'zh'" />
        <!-- <img alt="" src="../../../static/bannerSlotCn.png" v-if="lang == 'zh'" />
        <img src="../../../static/advertisementEnglishEn.png" alt="" v-else /> -->
        <img src="../../../static/英文-广告.jpg" alt="" v-else />
      </div>
      <ExhibitorsLive />
      <GoLogin :dialogVisible.sync="dialogVisible" v-if="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
      <Activities />
    </div>
    <el-backtop target=".homeContent" :bottom="100">
      <i class="el-icon-caret-top"></i>
    </el-backtop>
    <!-- <SelectProduct
      :selectvisible="selectvisible"
      :isHome="isHome"
      @fun="getMsgFormSelect"
      @funType="getProductType"
      @funMessage="getMessage"
      id="proTypeCard"
    /> -->
    <el-drawer :visible="selectvisible" width="100%" direction="btt" :with-header="false" :before-close="handleClose">
      <el-tabs tab-position="left">
        <el-tab-pane v-for="(item, index) in productsLists.conditons" :key="index" class="tabItem">
          <span slot="label">
            <el-checkbox @change="checkFirst(item)" v-model="item.choose" v-if="isHome">{{ item.title }}</el-checkbox>
            <span v-else>{{ item.title }}</span>
          </span>
          <el-collapse v-model="activeNames" @change="handleChange" accordion>
            <el-collapse-item :name="kk" v-for="(ii, kk) in item.children" :key="kk">
              <template slot="title">
                <el-checkbox @change="checkSecond(ii)" v-model="ii.choose" v-if="isHome">{{ ii.title }}</el-checkbox>
                <span v-else>{{ ii.title }}</span>
              </template>
              <div v-if="isHome">
                <el-checkbox @change="checkThird(item, ii, i)" v-model="i.choose" v-for="(i, k) in ii.children" :key="k">{{ i.title }}</el-checkbox>
              </div>
              <div v-else @click.stop>
                <el-radio v-model="typeThird" :label="i.title" v-for="(i, k) in ii.children" :key="k" @change="(e) => checkThird(item, ii, i)">{{
                  i.title
                }}</el-radio>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
      </el-tabs>
      <div class="bottom">
        <div class="btn" @click="submit">{{ $t('common.sure') }}</div>
      </div>
    </el-drawer>
    <Foot />
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import LoopImg from '../../../common/mobile/loopImg.vue';
import Foot from '../../../common/mobile/footBottom.vue';
import { screenList } from '../../../../Json/screenList';
import { screenListEn } from '../../../../Json/screenListEn.js';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { getrecommendedExhibits, addCollect, getbannerSlot } from '../../../../api/homePage';
import { forMat, hzExhibitionLogin, hzAudienceLogin, hzExhibitionIndex, hzAudienceIndex, hzZhanhui, baseFileUrl } from '../../../../utils/common';
import VRSee from '../../../components/homPage/mobile/VRSee.vue'; //VR全景看展
import Recommend from '../../../components/homPage/mobile/recommend.vue'; //展商推荐
import ExhibitorsLive from '../../../components/homPage/mobile/exhibitorsLive.vue'; //展商直播
import Activities from '../../../components/homPage/mobile/activities.vue'; //精彩活动
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框
import SelectProduct from '../../../common/mobile/searchProduct.vue'; //登录提示框
import * as tools from '../../../../utils/roulink';

export default {
  name: 'mobileHomepage',
  components: {
    MobileHead,
    LoopImg,
    Foot,
    swiper,
    swiperSlide,
    VRSee,
    Recommend,
    ExhibitorsLive,
    Activities,
    GoLogin,
    SelectProduct,
  },
  data() {
    return {
      baseUrl: forMat(),
      productsLists: null,
      activeNames: [0],
      // todo:把type进行一个判断，筛选一级，二级还是只有三级的数据
      type: null,
      typeThird: '',
      message: '',
      select: 0,
      category: [
        { key: 0, val: 0 },
        { key: 1, val: 1 },
      ],
      selectScreen: [],
      search: '',
      holder: '',
      dataSource: [],
      recommendExLists: [
        {
          imgUrl: require('../../../static/mining.png'),
          title: '井下开采',
          label: this.$t('mobileRecommend.UndergroundMining'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/tunneling.png'),
          title: '井下掘进',
          label: this.$t('mobileRecommend.UndergroundTunneling'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/transport.png'),
          title: '井下运输',
          label: this.$t('mobileRecommend.UndergroundTransportation'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/power.png'),
          title: '煤矿机电与动力',
          label: this.$t('mobileRecommend.CoalMineElectromechanicalandPower'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/proSystem.png'),
          title: '煤矿辅助生产系统',
          label: this.$t('mobileRecommend.CoalMineAuxiliaryProductionSystem'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/production.png'),
          title: '自动化控制和煤矿智能化',
          label: this.$t('mobileRecommend.SMARTMineAutomation'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/coal.png'),
          title: '煤炭加工利用',
          label: this.$t('mobileRecommend.CoalProcessingUtilization'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/openAir.png'),
          title: '露天采矿',
          label: this.$t('mobileRecommend.Open_AirMining'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/engineering.png'),
          title: '矿山服务与工程',
          label: this.$t('mobileRecommend.CoalMineServicesandEngineering'),
          lists: [],
        },
        {
          imgUrl: require('../../../static/mineral.png'),
          title: '矿用物资、工具及加工制造',
          label: this.$t('mobileRecommend.MineMaterialInstrumentsandProcessing'),
          lists: [],
        },
      ],
      RecommendExhibits: [],
      swiperOption: {
        loop: true,
        // slidesPerView: 4,
        // spaceBetween: 30,

        autoplay: {
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      lang: 'zh',
      toggle: false,
      dialogVisible: false,
      selectvisible: false, //选择产品弹窗
      isHome: false, //是否是首页
      selectProductType: '', //产品类型筛选
      message: '',
      inputValue: '',
    };
  },
  created() {
    document.documentElement.scrollTop = 0;

    this.setrecommendExhibits();
    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    this.lang = language == 'en' ? language : 'zh';
    this.toggle = language == 'en' ? true : false;
    if (language == 'en') {
      this.productsLists = screenListEn;
    } else {
      this.productsLists = screenList;
      localStorage.setItem('lang', 'zh');
    }
    this.holder = this.$t('homePage.handle.handle' + this.select);
  },
  watch: {
    select: {
      handler: function(newVal, oldVal) {
        if (this.select == '0') {
          this.holder = this.$t('homePage.handle.handle' + this.select);
        } else if (this.select == '1') {
          this.holder = this.$t('homePage.handle.handle' + this.select);
        } else {
          this.holder = this.$t('homePage.placeholder1');
        }
      },
      immediate: true,
      deep: true,
    },
    lang(newVal, oldVal) {
      if (newVal == 'en') {
        this.recommendExLists = [
          {
            imgUrl: require('../../../static/mining.png'),
            title: '井下开采',
            label: this.$t('mobileRecommend.UndergroundMining'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/tunneling.png'),
            title: '井下掘进',
            label: this.$t('mobileRecommend.UndergroundTunneling'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/transport.png'),
            title: '井下运输',
            label: this.$t('mobileRecommend.UndergroundTransportation'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/power.png'),
            title: '煤矿机电与动力',
            label: this.$t('mobileRecommend.CoalMineElectromechanicalandPower'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/proSystem.png'),
            title: '煤矿辅助生产系统',
            label: this.$t('mobileRecommend.CoalMineAuxiliaryProductionSystem'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/production.png'),
            title: '自动化控制和煤矿智能化',
            label: this.$t('mobileRecommend.SMARTMineAutomation'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/coal.png'),
            title: '煤炭加工利用',
            label: this.$t('mobileRecommend.CoalProcessingUtilization'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/openAir.png'),
            title: '露天采矿',
            label: this.$t('mobileRecommend.Open_AirMining'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/engineering.png'),
            title: '矿山服务与工程',
            label: this.$t('mobileRecommend.CoalMineServicesandEngineering'),
            lists: [],
          },
          {
            imgUrl: require('../../../static/mineral.png'),
            title: '矿用物资、工具及加工制造',
            label: this.$t('mobileRecommend.MineMaterialInstrumentsandProcessing'),
            lists: [],
          },
        ];
      }
    },
  },
  methods: {
    viewMore(title) {
      this.$router.push({
        name: 'exhibitsList',
        query: { type: title },
      });
    },
    submit() {
      this.selectvisible = false;
      window.scrollTo(0, 0);
      this.selectProductType = this.inputValue;
    },
    handleChange() {},

    handleClose() {
      this.selectvisible = false;
    },
    checkThird(first, second, third) {
      this.type = '';
      this.type = first.title + '-' + second.title + '-' + third.title;
      this.message = third.type;
      this.inputValue = third.title;
    },
    getElement(id) {
      return document.getElementById(id);
    },
    //根据展品推荐一级分类来调用接口
    setrecommendExhibits() {
      this.recommendExLists.map((item, i) => {
        let params = item.title;
        this.getRecommendedEx(params);
      });
    },
    async getRecommendedEx(params) {
      try {
        let { data } = await getrecommendedExhibits(params);
        this.recommendExLists.map((item) => {
          if (item.title == params) {
            data.data.list.map((i) => {
              item.lists.push({
                id: i.id,
                exhibitsName: i.exhibitsName, //展品名称
                column23: i.column23, //展品型号
                column19: i.column17, //一级分类
                exhibitsCoverImg: i.exhibitsCoverImg, //封面地址
                companyNameC: i.hzExhibitor.companyNameC, //公司名称
                collectStatus: i.collectStatus, //0=未收藏；1=已收藏
                hzExhibitorId: i.hzExhibitorId,
              });
            });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    //收藏or取消收藏 type:1=收藏展商;2=收藏展品;3=收藏直播;4=收藏活动
    async collection(item, type) {
      const willStatus = !item.collectStatus;
      const params = {
        objId: item.id,
        flag: willStatus,
        type: type,
      };
      // const toggleStatus = willStatus === true ? true : false;
      try {
        const { data } = await addCollect(params);
        if (data.code === 200) {
          if (!item.collectStatus && (item.collectStatus = !item.collectStatus)) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'success',
            });
          }
        } else {
          this.dialogVisible = true;
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
      }
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      tools.login(3);
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
    openPanel(event) {
      // 输入框聚焦, 显示弹层
      this.selectvisible = true;
      this.isHome = false;
      event.stopPropagation();
    },
    getMsgFormSelect(data) {
      this.selectvisible = data;
    },
    getProductType(data) {
      // todo:把type进行一个判断，筛选一级，二级还是只有三级的数据
      this.selectProductType = data;
      this.selectvisible = false;
    },
    getMessage(data) {
      this.message = data;
    },
    // 展品推荐查看更多
    goDetail(id) {
      this.$router.push({
        name: 'exhibItem_detail',
        query: {
          id,
        },
      });
    },
    searchClick() {
      const keyword = this.message;
      if (this.select == 0) {
        //搜展品
        if (keyword == undefined) {
          const keyword = '';
          this.$router.push({
            name: 'exhibitsList',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        } else {
          this.$router.push({
            name: 'exhibitsList',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        }
      }

      if (this.select == 1) {
        //搜展商

        if (keyword == undefined) {
          const keyword = 0;
          this.$router.push({
            name: 'exhibition',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        } else {
          this.$router.push({
            name: 'exhibition',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        }
      }
    },
    routerDetail() {},
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  .homeContent {
    margin-top: 13.3vw;
    background: #f6f6f7;
    .bbody {
      // background-image: url('../../../static/IMG_exhibits.png');
      // padding-bottom: 65px;

      .container {
        padding: 0px 4vw;
        box-sizing: border-box;
        margin: 0 auto;
        .goldBox {
          position: relative;
          top: -8.6vw;
          z-index: 20;

          .title {
            font-size: 4.8vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333;
            text-align: center;
            background: #facd00;
            box-shadow: 0px 0px 6.8vw 0px #e8ecf0;
            padding: 4vw 0 3.3vw 0px;
            box-sizing: border-box;
            z-index: 20;
            color: #006fb8;
          }

          //搜索框
          .search {
            padding: 0 2.6vw;
            padding-bottom: 5.3vw;
            box-sizing: border-box;
            height: 28.5vw;
            background: #facd00;

            .row1 {
              display: flex;
              .selectBox {
                width: 34vw !important;
                margin-right: 2.6vw;
                font-size: 3.7vw;

                .el-select-dropdown__item {
                  font-size: 2.1vw !important;
                }
              }

              .selecTree {
                width: 49vw;
                .inputSelect {
                  width: 100%;
                  -webkit-appearance: none;
                  background-color: #fff;
                  border-radius: 4px;
                  border: 1px solid #dcdfe6;
                  height: 9.6vw;
                  line-height: 9.6vw;
                  padding: 0 8vw 0 4vw;
                  box-sizing: border-box;
                  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
                  width: 100%;
                  font-size: 3.7vw;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  position: relative;
                  overflow: hidden;
                  span {
                    font-size: 3.7vw;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                  }
                  i {
                    position: absolute;
                    right: 0;
                    top: 0;
                    line-height: 9.6vw;
                    height: 100%;
                    width: 25px;
                    text-align: center;
                    transition: all 0.3s;
                    line-height: 9.6vw;
                  }
                }

                .el-select {
                  width: 100%;
                }
              }
            }

            //右边的输入框以及按钮
            .row2 {
              display: flex;
              margin-top: 4vw;
              .searchBox {
                width: 60vw;
              }

              //右侧的蓝色按钮
              .btn {
                width: 24vw;
                margin-left: 2.6vw;

                .el-button {
                  width: 100%;
                  background: #006fb8;
                  font-size: 4.3vw;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                  height: 9.6vw;
                  padding: 0;
                  box-sizing: border-box;
                  .el-icon-search:before {
                    font-size: 3.3vw !important;
                  }
                }
              }
            }
          }
        }
      }
    }
    .recommendEx {
      .recommended {
        font-size: 4.8vw;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        text-align: center;
        padding: 1.2vw 0px 7.2vw 0px;
      }
      .exhibitionsLists {
        padding-bottom: 10.6vw;
        box-sizing: border-box;
        .exItem {
          background: linear-gradient(0deg, #f6f6f7 0%, #e3f0f8 100%);
          height: 71vw;
          margin-bottom: 6.6vw;
          .navTitle {
            width: 100%;
            display: flex;
            height: 13.3vw;
            line-height: 13.3vw;

            justify-content: center;
            .img {
              width: 12vw;
              height: 11vw;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 1.5vw;

              img {
                width: fit-content;
                height: fit-content;
                max-width: 12vw;
                max-height: 11vw;
              }
            }
            .titlee {
              font-size: 4.3vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              margin-left: 2.6vw;
              color: #006fb8;
            }
          }
          .content::-webkit-scrollbar {
            display: none;
          }
          .content {
            display: flex;
            position: relative;
            width: 100%;
            overflow: hidden;
            overflow-x: scroll;

            .swiper-slide {
              width: 39.3vw !important;
              height: 56.4vw;
              border: 1px solid #e0e0e0;
              margin-left: 0;
              background: #ffffff;
              margin: 2vw 1.4vw;
              &:hover {
                box-shadow: 0px 0px 2vw 0px #b8bfc5;
              }

              //   margin-left: 28px;
              //   margin-bottom: 28px;
              .parameter {
                height: 20vw;
                padding-top: 4.1vw;
                box-sizing: border-box;
                .title {
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  //margin-top: 30px;
                  margin-left: 3.2vw;
                  font-size: 4.3vw;
                  max-width: 30.9vw;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  word-break: break-all;
                  overflow: hidden;
                }
                .english {
                  margin-top: 1.8vw;
                  margin-left: 3.2vw;
                  font-size: 2.6vw;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #333333;
                  max-width: 30.9vw;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
                .txt {
                  font-size: 2.6vw;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  margin-top: 10px;
                  margin-left: 3.2vw;
                  max-width: 30.9vw;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
              }

              .backImg {
                width: 30.9vw;
                height: 22.9vw;
                margin: 4vw auto 0;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .companyName {
                margin-top: 2.6vw;
                margin-left: 3.2vw;
                margin-right: 3.2vw;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .leftTitle {
                  font-size: 2.6vw;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #666;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
            .viewMore {
              width: 12.2vw;
              height: 56vw;
              background: #fdd000;
              font-size: 4.3vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #006fb8;
              line-height: 12.2vw;
              vertical-align: middle;
              writing-mode: vertical-lr;
              text-align: center;
              margin: 2vw 1.4vw;
              span {
                margin-top: 4.67vw;
              }
              img {
                width: 4.3vw;
                height: 4.3vw;
              }
            }
          }
        }
      }
    }
    .advertising {
      width: 100%;
      height: 42.7vw;
      margin: 0 auto;
      justify-content: center;
      align-items: center;
      display: flex;
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
    }
  }
}
</style>
<style scoped>
.el-cascader {
  width: 49vw;
}
.selectBox >>> .el-input__inner {
  width: 34vw;
  height: 9.6vw;
  line-height: 9.6vw;
  font-size: 3.7vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.el-select-dropdown__item {
  font-size: 3.7vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.el-select-dropdown__item.selected {
  color: #006fb8;
}
.row2 >>> .el-input__inner {
  width: 60vw;
  height: 9.6vw;
  line-height: 9.6vw;
  font-size: 3.7vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.content a {
  text-decoration: none;
}
</style>
<style scoped>
.el-dialog__wrapper >>> .el-dialog__footer {
  text-align: center;
}
.dialog-footer >>> .el-button--primary {
  width: 28.8vw;
  height: 9.6vw;
  background: #006fb8;
  border-radius: 1vw;
}
.el-dialog__wrapper >>> .el-dialog {
  width: 66.67vw !important;
  /* height: 75.47vw; */
  background: #ffffff;
}
>>> .el-dialog__headerbtn {
  color: #312c2b;
  font-size: 2.93vw;
}
</style>
<style scoped>
.el-drawer__wrapper >>> .el-drawer {
  height: 70% !important;
  /* position: fixed;
  -webkit-transform: translateZ(0);
  transform: translateZ(0); */
}
.el-drawer__wrapper >>> .el-drawer__body {
  height: 85%;
}
.el-tabs--left >>> .el-tabs__item.is-left {
  text-align: left;
  padding-left: 4vw;
  box-sizing: border-box;
  max-height: 10vw;
  /* height: 8vw; */
  line-height: 4vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding-top: 1vw;
  padding-bottom: 1vw;
  box-sizing: border-box;

  width: 100%;
  margin-top: 3vw;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
  vertical-align: middle;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.el-tabs--left >>> .el-tabs__nav-wrap.is-left.is-scrollable {
  padding-top: 4vw;
  padding-bottom: 4vw;
  box-sizing: border-box;
}
.el-tabs--left >>> .el-tabs__nav-wrap.is-left::after {
  width: 1px;
  margin-right: 0px;
}
>>> .el-tabs__item.is-active {
  background: #f4f4f4 !important;
  color: #006fb8 !important;
}
/* .el-drawer__wrapper >>> span {
  width: 100%;
  white-space: normal;
} */
.el-tabs >>> .el-tabs__header {
  width: 39.2%;
  /* padding: 5.3vw 0 5.3vw 4vw; */
  /* box-sizing: border-box; */
  margin: 0;
}
.el-tabs >>> .el-tabs__content {
  padding-top: 5.3vw;
  padding-bottom: 5.3vw;
  box-sizing: border-box;
}
.el-tabs {
  height: 85%;
}
.el-drawer__wrapper >>> .el-tabs__active-bar {
  background-color: transparent !important;
}
.el-collapse {
  border-top: 0px;
}
.el-checkbox >>> .el-checkbox__label {
  white-space: normal;
  vertical-align: text-top;
}
.el-radio >>> .el-radio__label {
  white-space: normal;
  vertical-align: text-top;
  display: inline-block;
  padding-left: 1.3vw;
  font-size: 3.2vw;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; */
}
.el-collapse-item >>> .el-collapse-item__wrap {
  background: #f6f6f7;
  max-height: 60vw;
  overflow: hidden;
  overflow-y: auto;
}
.el-collapse-item >>> .el-checkbox,
.el-radio {
  height: 8vw;
  line-height: 4vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 2vw;
  display: block;
}
.el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px;
  padding: 0px 4vw;
  box-sizing: border-box;
  width: 100%;
  /* height: inherit; */
  overflow: hidden;
  overflow-y: scroll;
}
.el-collapse-item >>> .el-collapse-item__header {
  padding: 0px 4vw;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 3.7vw;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
.el-collapse-item >>> .el-collapse-item__header span {
  /* width: 51.2vw; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-drawer__wrapper >>> .bottom {
  width: 100%;
  height: 15%;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(109, 109, 109, 0.35);
  position: relative;
  padding-right: 6.4vw;
  box-sizing: border-box;
}
.el-drawer__wrapper >>> .btn {
  width: 24vw;
  height: 9.6vw;
  background: #006fb8;
  border-radius: 1vw;
  line-height: 9.6vw;
  text-align: center;
  font-size: 4.3vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  float: right;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.el-tabs >>> .el-tabs__nav-prev {
  display: none;
}
.el-tabs >>> .el-tabs__nav-next {
  display: none;
}
.el-tabs--left >>> .el-tabs__nav-scroll {
  overflow: scroll !important;
  /* overflow-y: hidden !important; */
  height: 100% !important;
}
</style>
